import {
  DataTypeUser,
  DataTypeUserDocument,
  DataTypeUserOrder,
  UserDocumentResource,
} from 'api-client'
import * as R from 'ramda'

import { UserDocument } from '../api/user-documents'
export interface TransloaditUpload {
  basename: string
  ext: string
  field: string
  from_batch_import: boolean
  id: string
  is_tus_file: boolean
  md5hash: string
  mime: string
  name: string
  original_basename: string
  original_id: string
  original_md5hash: string
  original_name: string
  original_path: string
  size: number
  ssl_url: string
  tus_upload_url: string
  type: string
  url: string
}

export interface TransloaditAssemblyStub {
  uploads: TransloaditUpload[]
}
export const transformUploadToApiUserDocument = (
  upload: TransloaditUpload,
  userId: string,
  orderId: string,
  platformId?: string,
): UserDocumentResource => ({
  attributes: {
    fileName: upload.name,
    isActive: true,
    mimeType: upload.mime,
    orderId: platformId ? undefined : orderId,
    size: upload.size,
    transloaditId: upload.id,
    uploadDate: new Date().toISOString(),
    url: upload.ssl_url,
  },
  id: upload.id,
  relationships: {
    user: {
      data: {
        id: userId,
        type: DataTypeUser.User,
      },
    },
    userOrder: platformId
      ? {
          data: {
            id: platformId,
            type: DataTypeUserOrder.UserOrder,
          },
        }
      : undefined,
  },
  type: DataTypeUserDocument.UserDocument,
})

export const transformUserDocumentToApiUserDocument = (
  userDocument: UserDocument,
): UserDocumentResource => ({
  attributes: {
    ...R.pick(
      [
        'fileName',
        'isActive',
        'mimeType',
        'orderId',
        'size',
        'transloaditId',
        'uploadDate',
        'url',
      ],
      userDocument,
    ),
  },
  id: userDocument.id,
  relationships: {
    user: {
      data: {
        id: userDocument.user.id,
        type: DataTypeUser.User,
      },
    },
    userOrder: userDocument.userOrder
      ? {
          data: {
            id: userDocument.userOrder.id,
            type: DataTypeUserOrder.UserOrder,
          },
        }
      : undefined,
  },
  type: DataTypeUserDocument.UserDocument,
})
